import { Box, Stack } from "@mui/material";
import FormRowLink from "@/components/common/forms/formRowLink";
import FormStatusChip from "@/components/common/forms/formStatusChip";
import FormStatusIcon, {
  FormStatus,
} from "@/components/common/forms/formStatusIcon";
import IntakeFormHeader from "@/components/common/intakeForms/intakeFormHeader";
import { ClientByTokenQuery } from "@/graphql/queries/clientByToken.graphql.types";
import useFormSubmissionVersionsList from "@/hooks/intakeForms/useFormSubmissionVersionsList";
import { formatLogDate, shouldShowFormExpiredToClient } from "@/utils/forms";

type IntakeFormSubmission =
  ClientByTokenQuery["clientAccessTokenByPk"]["client"]["formSubmissions"][number];

type Props = {
  formSubmission: IntakeFormSubmission;
  baseUrl: string;
};

export default function ClientFormSubmissionVersions({
  formSubmission,
  baseUrl,
}: Props) {
  const { versions, submittedAt } = formSubmission;

  const submitted = !!submittedAt || versions?.length > 0;

  const submissionVersions = useFormSubmissionVersionsList(
    formSubmission,
    `${baseUrl}/intake-form`
  );

  const getFormStatus = () => {
    if (shouldShowFormExpiredToClient(formSubmission)) {
      return FormStatus.EXPIRED;
    }
    return submitted ? FormStatus.SUBMITTED : FormStatus.INCOMPLETE;
  };

  const formStatus = getFormStatus();

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <FormStatusChip status={formStatus} />
      </Box>
      <Stack
        sx={{
          mt: 1,
        }}
      >
        {submissionVersions.map((version, idx) => (
          <FormRowLink
            key={version.id}
            url={version.url}
            showButton={!submitted}
          >
            <IntakeFormHeader
              name={version.name}
              subtitle={
                version.submittedAt
                  ? `Submitted on ${formatLogDate(version.submittedAt)}`
                  : ""
              }
              icon={idx === 0 ? <FormStatusIcon status={formStatus} /> : null}
              highlightName={idx === 0}
            />
          </FormRowLink>
        ))}
      </Stack>
    </Box>
  );
}
